declare namespace $ {

	export class $mol_icon_home extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=home.view.tree.d.ts.map